import { createContext, useContext, createElement } from 'react';
var createMobXContext = function (storeInstance) {
    var StoreContext = createContext(null);
    var StoreProvider = function (_a) {
        var children = _a.children;
        return createElement(StoreContext.Provider, { value: storeInstance }, children);
    };
    StoreProvider.displayName = storeInstance.constructor.name + "Provider";
    var useStore = function () {
        var store = useContext(StoreContext);
        if (!store)
            throw new Error("Trying to access " + storeInstance.constructor.name + " outside of provider");
        return store;
    };
    return [StoreContext, StoreProvider, useStore];
};
export default createMobXContext;
//# sourceMappingURL=createMobXContext.js.map